import Vue from 'vue'

let documentClickHandler = undefined

Vue.directive('outside-click', {
  bind(el, binding, vnode) {
    documentClickHandler = (elem) => {
      elem.stopPropagation()

      const { handler, exclude } = binding.value
      let clickedOnExcludedElement = false

      exclude.forEach(refName => {
        const vueComponentExcludedElement = vnode.context.$refs[refName]
        if (!vueComponentExcludedElement) {
          console.warn(`Element with ref "${refName}" not found.`)
          return
        }

        let excludedElement = vueComponentExcludedElement.$vnode.elm
        if (!clickedOnExcludedElement) {
          clickedOnExcludedElement = excludedElement.contains(elem.target)
        }
      })

      if (!el.contains(elem.target) && !clickedOnExcludedElement) {
        vnode.context[handler]()
      }
    }

    document.addEventListener('click', documentClickHandler)
    document.addEventListener('touchstart', documentClickHandler)
  },
  unbind() {
    document.removeEventListener('click', documentClickHandler)
    document.removeEventListener('touchstart', documentClickHandler)
  }
})
